//прокрутка
document.addEventListener("DOMContentLoaded", function () {
    function hasStickyPanel() {
        return document.querySelector(".sticky-atc-panel") !== null;
    }

    if (hasStickyPanel()) {
        return;
    }

    // Создаем кнопку
    const scrollButton = document.createElement("button");
    scrollButton.id = "scrollButton";
    scrollButton.className = "scroll-btn";
    document.body.appendChild(scrollButton);

    // Добавляем SVG-иконку внутрь кнопки
    scrollButton.innerHTML = `
        <svg class="scroll-icon" width="30" height="30" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M419.5 337.5L256.5 174.5L93.5 337.5" stroke="white" stroke-width="24" stroke-linecap="round"/>
        </svg>
    `;

    // Добавляем стили
    const style = document.createElement("style");
    style.innerHTML = `
        .scroll-btn {
            position: fixed;
            right: 20px;
            bottom: 50px;
            width: 55px;
            height: 55px;
            background-color: rgba(0, 0, 0, 0.3);
            border: none;
            border-radius: 50%;
            cursor: pointer;
            transition: opacity 0.3s, background-color 0.3s, transform 0.3s;
            opacity: 0;
            pointer-events: none;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 39;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            border: 1px solid #0048446e;
                                     }

        .scroll-btn:hover {
            background-color: rgba(0, 0, 0, 0.6);
        }

        .scroll-btn.show {
            opacity: 1;
            pointer-events: auto;
        }

        .scroll-icon {
            width: 30px;
            height: 30px;
            transition: transform 0.3s ease;
        }

        /* Вниз */
        .scroll-btn.down .scroll-icon {
            transform: rotate(180deg);
        }

        /* Назад (поворачивается влево) */
        .scroll-btn.back .scroll-icon {
            transform: rotate(270deg);
        }

        /* Мобильные стили */
        @media (max-width: 768px) {
            .scroll-btn {
                width: 45px;
                height: 45px;
                right: 5px;
                bottom: 30px;
            }

            .scroll-icon {
                width: 25px;
                height: 25px;
            }
        }
    `;
    document.head.appendChild(style);

    let lastScrollPosition = 0;
    let isAtTop = false;
    let isScrolling;
    let hasHistory = document.referrer && new URL(document.referrer).origin === window.location.origin;

    // Показываем "Назад", если есть предыдущая страница
    if (hasHistory) {
        scrollButton.classList.add("show", "back");
    }

    window.addEventListener("scroll", () => {
        clearTimeout(isScrolling);
        scrollButton.classList.remove("show");

        isScrolling = setTimeout(() => {
            if (window.scrollY > 100) {
                scrollButton.classList.add("show");
                scrollButton.classList.remove("back");
            }
        }, 500);

        if (window.scrollY === 0 && !isAtTop) {
            scrollButton.classList.add("down");
            scrollButton.classList.add("show");
            isAtTop = true;
        } else if (window.scrollY > 0 && isAtTop) {
            scrollButton.classList.remove("down");
            isAtTop = false;
        }
    });

    scrollButton.addEventListener("click", () => {
        if (scrollButton.classList.contains("back")) {
            history.back();
            return;
        }

        if (!isAtTop) {
            lastScrollPosition = window.scrollY;
            window.scrollTo({ top: 0, behavior: "smooth" });

            setTimeout(() => {
                scrollButton.classList.add("down");
                scrollButton.classList.add("show");
            }, 500);

            isAtTop = true;
        } else {
            window.scrollTo({ top: lastScrollPosition, behavior: "smooth" });
            scrollButton.classList.remove("down");
            isAtTop = false;
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const menuBox = document.querySelector(".catmenu-box");
  let lastScrollTop = 0;
  let isHeaderHidden = false;

  if (!header) {
    console.warn("❌ Шапка не найдена!");
    return;
  }

  // Добавляем js-active и убираем js-before-init
  header.classList.remove("js-before-init");
  header.classList.add("js-active");

  const mobileThreshold = 150;
  const desktopThreshold = 80;
  const freezePoint = 200;

  function isMenuOpen() {
    return menuBox && window.getComputedStyle(menuBox).display !== "none";
  }

  function showHeader() {
    header.classList.remove("header-hidden");
    header.style.transform = "translateY(0)";
    isHeaderHidden = false;
  }

  function hideHeader() {
    header.classList.add("header-hidden");
    header.style.transform = "translateY(-100%)";
    isHeaderHidden = true;
  }

  function enforceGravity() {
    const computedTransform = getComputedStyle(header).transform;
    if (computedTransform && computedTransform !== 'none' && computedTransform.includes('matrix')) {
      const matrix = new DOMMatrix(computedTransform);
      const y = matrix.m42;
      const headerHeight = header.offsetHeight;

      if (y > 0 || Math.abs(y) > headerHeight) {
        header.style.transform = isHeaderHidden ? "translateY(-100%)" : "translateY(0)";
      }
    }
  }

  function handleScroll() {
    if (isMenuOpen()) return;

    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    const isMobile = window.innerWidth <= 768;
    const threshold = isMobile ? mobileThreshold : desktopThreshold;

    if (currentScroll > lastScrollTop && currentScroll > threshold) {
      if (!isHeaderHidden) hideHeader();
    } else if (currentScroll < lastScrollTop || currentScroll < freezePoint) {
      if (isHeaderHidden) showHeader();
    }

    enforceGravity();
    lastScrollTop = currentScroll;
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      enforceGravity();
      setTimeout(() => {
        handleScroll();
      }, 100);
    }
  });

  window.addEventListener("scroll", handleScroll, { passive: true });

  header.style.transition = "transform 0.4s ease-in-out";
});
